import { createSelector } from 'reselect';
import { getWorkspaceID } from './workspaces';

const getRawContactGroups = state => state.contactGroups;

export const getWorkspaceContactGroups = createSelector(
	[ getRawContactGroups, getWorkspaceID ],
	( contactGroups, workspaceID ) => contactGroups.filter( group => group.workspace_id === workspaceID ).toArray()
);
